import { Component } from '@angular/core'
import { DatePipe } from '@angular/common'

import { Button, Icon } from '@shared/ui'
import { NotificationModalBase } from '../notification-modal-base'

/** Modal genérico: lo abre el panel cuando la notificación trae `modalBody`. */
@Component({
  selector: 'notification-modal',
  imports: [Icon, Button, DatePipe],
  host: { class: 'card-panel block rounded-[20px] p-4' },
  templateUrl: './notification-modal.html'
})
export class NotificationModal extends NotificationModalBase {}
